import { PROJECT_HIERACRCHY_R } from 'constants/actionTypes';

export const getProjectHierarchy = () => ({
  type: PROJECT_HIERACRCHY_R
});
